var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _path8, _g4, _path9, _g5, _path10, _g6, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 73,
    viewBox: "0 0 156 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1380_14330)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.09 -3.22412C30.5515 -2.61099 30.8359 -1.90936 30.9307 -1.13187C31.7714 -1.85879 32.7322 -2.08002 33.8194 -1.79558C33.3137 -1.54906 32.9092 -1.18876 32.5931 -0.721009C36.1835 -1.09395 38.99 0.195534 41.019 3.16008C40.9937 3.21065 40.9621 3.22329 40.9179 3.18536C38.8699 1.71257 36.588 1.08047 34.0723 1.29539C37.8459 2.22457 40.0329 4.60126 40.6334 8.42546C39.3882 6.94003 37.9849 5.63791 36.4173 4.51277C35.9622 4.20304 35.4882 3.94388 34.9888 3.74793C36.7018 5.87178 37.3402 8.28008 36.9041 10.9791C36.2277 8.58349 34.9509 6.57341 33.0735 4.94892C33.4338 6.77568 33.5034 8.61509 33.2758 10.4671C33.2063 11.0044 33.0988 11.5354 32.9408 12.0537C32.5236 10.3723 32.0243 8.72255 31.4364 7.09805C31.114 6.22576 30.6716 5.42299 30.109 4.69608C29.5464 5.46092 29.104 6.29529 28.7816 7.19919C28.2064 8.79208 27.7133 10.4166 27.3025 12.0537C26.7146 9.68334 26.6704 7.31297 27.1761 4.94892C25.305 6.56709 24.0345 8.57717 23.3708 10.9791C22.9157 8.27376 23.5541 5.86546 25.2861 3.74793C24.3759 4.16511 23.5225 4.69608 22.7324 5.3345C21.6073 6.25736 20.5896 7.27504 19.6667 8.40018C20.0713 5.13223 21.8411 2.88195 24.9764 1.65568C25.3746 1.50398 25.7854 1.38388 26.2026 1.29539C24.989 1.15 23.8006 1.25114 22.6249 1.60511C21.4113 1.96541 20.2862 2.50269 19.2559 3.21697C20.2799 1.55455 21.7274 0.372522 23.5984 -0.335429C24.9384 -0.758935 26.2974 -0.879034 27.6817 -0.695725C27.3657 -1.1698 26.9611 -1.53642 26.4555 -1.79558C27.5111 -2.06738 28.4655 -1.86511 29.3126 -1.18244C29.4516 -1.90936 29.7108 -2.59202 30.0774 -3.22412L30.09 -3.22412Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.110127 8.17236C9.50944 10.0118 18.8961 11.8828 28.2765 13.7917C28.4218 16.8637 28.5293 19.9294 28.6115 22.9888C25.6596 21.4654 22.6128 20.1822 19.4713 19.133C16.1654 18.0457 12.79 17.7929 9.35773 18.3681C11.4057 18.4313 13.4285 18.6652 15.4385 19.0824C17.8721 19.7714 20.2172 20.6753 22.4864 21.7941C24.2753 22.6854 26.0262 23.6335 27.7455 24.6322C24.9453 26.3642 22.1008 28.0329 19.2185 29.6384C19.6862 30.2137 20.1793 30.7699 20.6976 31.3009C20.7482 31.3325 20.7987 31.3325 20.8493 31.3009C23.4535 29.6195 26.0831 27.9697 28.7379 26.3705C28.9591 31.2124 29.1361 36.0479 29.2752 40.8835C26.437 37.742 23.58 34.6067 20.7229 31.4779C19.8443 32.0467 18.9151 32.5335 17.9416 32.9317C16.0264 33.5511 14.0858 33.6523 12.12 33.2414C11.4247 33.0644 10.7231 32.8938 10.0278 32.7294C13.3526 32.5714 16.3677 31.5347 19.0668 29.6132C12.6952 22.6158 6.35526 15.6058 0.0279538 8.58323C-0.0162931 8.43152 0.00899082 8.29246 0.103806 8.17236H0.110127Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8114 8.17344C60.1653 8.09759 60.3107 8.23033 60.2475 8.58431C53.8886 15.5816 47.5487 22.5916 41.2213 29.6142C43.9204 31.5485 46.9292 32.5851 50.2604 32.7305C49.1795 33.0149 48.0923 33.2551 46.9924 33.4448C44.7674 33.6597 42.6688 33.2362 40.7093 32.1679C40.3174 31.9404 39.9255 31.7065 39.5336 31.4789C36.6892 34.6141 33.8447 37.7493 31.0066 40.8846C30.9877 40.7897 30.975 40.6949 30.9561 40.6064C31.133 35.8594 31.329 31.1186 31.5439 26.3716C34.1861 27.9961 36.8156 29.6395 39.4325 31.3019C39.4831 31.3335 39.5336 31.3335 39.5842 31.3019C40.0646 30.7457 40.5576 30.2021 41.0633 29.6648C38.1873 28.0403 35.3428 26.3589 32.5363 24.6333C35.7979 22.6611 39.2176 21.0177 42.8016 19.7029C44.0784 19.2415 45.3869 18.9191 46.7332 18.7295C48.1239 18.5525 49.5208 18.4324 50.9241 18.3692C47.5487 17.8003 44.2238 18.0405 40.9622 19.0835C37.7638 20.1454 34.6665 21.4475 31.664 22.9962C31.7209 19.9305 31.8347 16.8648 31.999 13.7991C41.2719 11.9218 50.5448 10.0445 59.8114 8.17976V8.17344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.118 19.488H129.324V26.6054H122.118V19.488ZM129.324 8.53369H133.066V30.3474H129.324C129.336 29.1591 129.324 27.9771 129.279 26.7887C128.11 27.9581 126.941 29.1338 125.765 30.3032C123.331 30.3474 120.898 30.3664 118.47 30.3474C118.458 26.6686 118.47 22.9835 118.515 19.3047C119.684 18.1353 120.853 16.9596 122.029 15.7902C124.463 15.7459 126.896 15.727 129.324 15.7459V8.53369Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1380_14330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 8,
    width: 6,
    height: 5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M139.039 8.36768H134.962V12.2804H139.039V8.36768Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1380_14330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.164 8.53174H138.906V12.1853H135.164V8.53174Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1380_14330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 11,
    width: 15,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9594 11.9517H68.124V30.5354H82.9594V11.9517Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1380_14330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7714 12.0907H82.8078V15.8327H71.9547V19.3914H82.8078C82.8205 21.825 82.8078 24.2586 82.7636 26.6922C81.5626 27.8931 80.3616 29.0941 79.1606 30.2951C75.5134 30.3394 71.8662 30.3583 68.2127 30.3394V26.5973H79.0658V23.0386H68.2127C68.2 20.5734 68.2127 18.1083 68.2569 15.6431C69.4452 14.4674 70.6146 13.279 71.7714 12.0844V12.0907Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1380_14330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 15,
    width: 16,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.589 15.5356H84.918V30.5354H99.589V15.5356Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1380_14330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6479 19.4867H95.8539V26.6041H88.6479V19.4867ZM88.5531 15.7446H99.5011V30.3461H95.8539C95.8665 29.1578 95.8539 27.9757 95.8096 26.7874C94.6402 27.9568 93.4709 29.1325 92.2952 30.3019C89.8616 30.3461 87.428 30.3651 85.0007 30.3461C84.9881 26.6673 85.0007 22.9822 85.045 19.3033C86.2333 18.1276 87.4027 16.9393 88.5595 15.7446H88.5531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1380_14330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 15,
    width: 16,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.378 15.5356H101.543V30.5354H116.378V15.5356Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1380_14330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.688 15.7446H105.431V26.6041H112.548V15.7446H116.29C116.303 19.3982 116.29 23.0454 116.246 26.6989C115.045 27.8999 113.844 29.1009 112.643 30.3019C108.996 30.3461 105.348 30.3651 101.695 30.3461V15.7446H101.688Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1380_14330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 15,
    width: 6,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.039 15.5356H134.962V30.5354H139.039V15.5356Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1380_14330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.164 15.7446H138.906V30.3461H135.164V15.7446Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1380_14330",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 140,
    y: 15,
    width: 16,
    height: 16
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.828 15.5356H140.992V30.5354H155.828V15.5356Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1380_14330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.836 19.4867H151.953V26.6041H144.836V19.4867ZM144.652 15.7446H155.689V30.3461H151.947C151.959 29.1578 151.947 27.9757 151.902 26.7874C150.733 27.9568 149.564 29.1325 148.388 30.3019C145.954 30.3461 143.521 30.3651 141.094 30.3461C141.081 26.6673 141.094 22.9822 141.138 19.3033C142.326 18.1276 143.495 16.9393 144.652 15.7446Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75718 72.663V58.7448H0.0078125V56.3921H12.5628V58.7448H7.81348V72.663H4.75718Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.905 72.8829C13.1345 72.8829 11.5074 70.7501 11.5074 67.1441C11.5074 63.5381 13.1345 61.4053 15.905 61.4053C18.3676 61.4053 19.8408 62.9004 19.8408 65.4071H19.8848V61.6252H22.7872V72.663H19.8848V68.8591H19.8408C19.8408 71.3877 18.3676 72.8829 15.905 72.8829ZM14.4758 67.1441C14.4758 69.2989 15.4872 70.5522 17.2463 70.5522C19.0053 70.5522 20.0387 69.167 20.0387 67.1441C20.0387 65.0992 19.0053 63.714 17.2463 63.714C15.4872 63.714 14.4758 64.9893 14.4758 67.1441Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4329 72.663L28.6176 67.0342H28.5736V72.663H25.6712V55.7324H28.5736V66.8143H28.6176L33.0591 61.6252H36.4892L31.8058 66.8802L36.9949 72.663H33.4329Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5975 72.8829C39.1894 72.8829 37.1445 70.7501 37.1445 67.1441C37.1445 63.5161 39.1894 61.4053 42.5975 61.4053C45.9836 61.4053 48.0065 63.5161 48.0065 67.1441V67.4739H39.959C40.0689 69.4968 41.0364 70.6841 42.5975 70.6841C43.9607 70.6841 44.9062 69.9365 45.1921 68.7272H48.0065C47.5887 71.3438 45.5878 72.8829 42.5975 72.8829ZM39.981 66.4845H45.1701C44.9942 64.6595 44.0487 63.6041 42.5975 63.6041C41.1243 63.6041 40.1788 64.6595 39.981 66.4845Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5686 72.663L60.559 66.1986H57.7225L53.1051 56.3921H56.6012L60.9108 65.9348H60.9547L65.2424 56.3921H68.5405L60.8448 72.663H57.5686Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.203 72.8829C69.597 72.8829 67.4422 70.7501 67.4422 67.1441C67.4422 63.5381 69.597 61.4053 73.203 61.4053C76.809 61.4053 78.9418 63.5381 78.9418 67.1441C78.9418 70.7501 76.809 72.8829 73.203 72.8829ZM73.203 70.5522C74.962 70.5522 75.9954 69.2989 75.9954 67.1441C75.9954 64.9893 74.962 63.714 73.203 63.714C71.444 63.714 70.4105 64.9893 70.4105 67.1441C70.4105 69.2989 71.444 70.5522 73.203 70.5522Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8704 72.8829C82.4957 72.8829 81.1105 71.2118 81.1105 68.3534V61.6252H84.0129V68.2215C84.0129 69.7167 84.7605 70.5742 86.0578 70.5742C87.509 70.5742 88.3665 69.4748 88.3665 67.5838V61.6252H91.2689V72.663H88.3665V68.7712H88.3225C88.3225 71.3438 87.0252 72.8829 84.8704 72.8829Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0493 67.6718V72.663H94.1469V61.6252H97.0493V66.1766H97.0932C97.0932 63.1643 98.3246 61.4053 100.413 61.4053C101.051 61.4053 101.667 61.5372 102.128 61.7571L101.271 64.3516C100.853 64.1098 100.281 63.9559 99.7318 63.9559C98.0387 63.9559 97.0493 65.3411 97.0493 67.6718Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.828 72.8829C109.914 72.8829 107.43 70.7061 107.122 66.9682H110.112C110.31 69.167 111.695 70.4423 113.872 70.4423C116.115 70.4423 117.412 69.5408 117.412 68.0016C117.412 66.1107 115.477 65.8248 113.344 65.495C110.662 65.1212 107.561 64.6595 107.561 61.0755C107.561 57.8872 109.892 56.1722 113.828 56.1722C117.434 56.1722 119.743 58.283 120.051 61.845H117.038C116.906 59.8002 115.675 58.6128 113.674 58.6128C111.761 58.6128 110.64 59.4264 110.64 60.8336C110.64 62.4387 112.421 62.7245 114.466 63.0324C117.214 63.4501 120.512 63.9339 120.512 67.6938C120.512 70.948 118.028 72.8829 113.828 72.8829Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.628 72.8829C124.22 72.8829 122.175 70.7501 122.175 67.1441C122.175 63.5161 124.22 61.4053 127.628 61.4053C131.015 61.4053 133.037 63.5161 133.037 67.1441V67.4739H124.99C125.1 69.4968 126.067 70.6841 127.628 70.6841C128.992 70.6841 129.937 69.9365 130.223 68.7272H133.037C132.62 71.3438 130.619 72.8829 127.628 72.8829ZM125.012 66.4845H130.201C130.025 64.6595 129.08 63.6041 127.628 63.6041C126.155 63.6041 125.21 64.6595 125.012 66.4845Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M139.135 72.8829C136.365 72.8829 134.738 70.7501 134.738 67.1441C134.738 63.5381 136.365 61.4053 139.135 61.4053C141.598 61.4053 143.071 62.9004 143.071 65.4071H143.115V61.6252H146.018V72.663H143.115V68.8591H143.071C143.071 71.3877 141.598 72.8829 139.135 72.8829ZM137.706 67.1441C137.706 69.2989 138.718 70.5522 140.477 70.5522C142.236 70.5522 143.269 69.167 143.269 67.1441C143.269 65.0992 142.236 63.714 140.477 63.714C138.718 63.714 137.706 64.9893 137.706 67.1441Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.233 72.8829C150.881 72.8829 149.495 71.5636 149.495 69.3209V63.626H147.912V61.6252H149.671V57.9312H152.574V58.8547C152.574 60.2619 151.518 61.2514 149.759 61.5812V61.6252H155.828V63.626H152.398V68.9471C152.398 69.9585 153.035 70.5522 154.157 70.5522C154.684 70.5522 155.234 70.4203 155.63 70.2004V72.3772C154.97 72.685 154.069 72.8829 153.233 72.8829Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1380_14330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.819,
    height: 44.1015,
    fill: "white",
    transform: "translate(0.00878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a1acee50ded4d876d9b241e43e35bf8f.svg";
export { ForwardRef as ReactComponent };